import { InjectionToken } from '@angular/core';
import { getDateObject } from './getDateObject';

/**
 * @description     Generate a list of months in a native language
 * @param locale    Locale used for format the month
 */
export const getMonthOptions = (locale: string): any[] => {
    const months = [];
    // Start at the beginning of a year. The year doesn't matter
    const monthObj = getDateObject('2020-01-01');

    for (let i = 0; i < 12; i++) {
        monthObj.setMonth(i);
        months.push({
            label: monthObj.toLocaleDateString(locale, { month: 'long' }),
            value: monthObj.toLocaleDateString(locale, { month: '2-digit' })
        });
    }

    return months;
};

export type GetMonthOptionsProvider = (locale: string) => any[];
export const GET_MONTH_OPTIONS =
    new InjectionToken('GET_MONTH_OPTIONS', {
        factory: () => getMonthOptions
    });
